import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { CalendarBlank, Clock, MapPin, ArrowRight } from '@phosphor-icons/react';

const KIND = {
  mixin: { de: 'Mixin', en: 'Mixin', cls: 'bg-purple-100 text-purple-700' },
  training: { de: 'Gruppentraining', en: 'Group training', cls: 'bg-blue-100 text-blue-700' },
  academy: { de: 'Academy', en: 'Academy', cls: 'bg-teal-100 text-teal-700' },
  match: { de: 'Open Match', en: 'Open match', cls: 'bg-orange-100 text-orange-700' },
};

const STATUS = {
  waitlist: ['Warteliste', 'Waitlist', 'text-slate-500'],
  block_pending: ['Wartet auf Platzvervollständigung', 'Waiting for court to fill', 'text-amber-600'],
  awaiting_payment: ['Zahlung offen', 'Payment due', 'text-amber-600'],
  pending: ['Zahlung offen', 'Payment due', 'text-amber-600'],
  paid: ['Bezahlt', 'Paid', 'text-green-600'],
};

export const EventBookingCard = ({ ev, language, dateLocale }) => {
  const de = language === 'de';
  const k = KIND[ev.kind] || KIND.mixin;
  const st = STATUS[ev.status] || ['Angemeldet', 'Signed up', 'text-green-600'];
  const body = (
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`px-2 py-0.5 rounded-md text-[11px] font-bold uppercase ${k.cls}`} data-testid={`event-booking-kind-${ev.id}`}>{de ? k.de : k.en}</span>
          <p className="font-bold text-slate-900 truncate">{ev.title}</p>
        </div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-sm text-slate-500">
          <span className="flex items-center gap-1"><CalendarBlank size={14} />{format(new Date(`${ev.date}T00:00:00`), 'PP', { locale: dateLocale })}</span>
          <span className="flex items-center gap-1"><Clock size={14} />{ev.start_time}{ev.end_time ? ` - ${ev.end_time}` : ''}</span>
          {ev.court_name && <span className="flex items-center gap-1"><MapPin size={14} />{ev.court_name}</span>}
          {ev.trainer_name && <span>{ev.trainer_name}</span>}
          {ev.kind === 'match' && ev.max_players && <span>{ev.players}/{ev.max_players}</span>}
        </div>
      </div>
      <div className="text-right flex-shrink-0">
        {ev.amount > 0 && <p className="text-emerald-600 font-bold">{Number(ev.amount).toFixed(2)} CHF</p>}
        <span className={`text-xs font-bold uppercase ${st[2]}`} data-testid={`event-booking-status-${ev.id}`}>{de ? st[0] : st[1]}</span>
        {ev.link && <ArrowRight size={14} className="inline ml-1 text-slate-400" />}
      </div>
    </div>
  );
  const cls = 'block bg-slate-50 border border-slate-200 p-4 rounded-lg';
  return ev.link
    ? <Link to={ev.link} className={`${cls} hover:border-emerald-300 transition-colors`} data-testid={`event-booking-${ev.kind}-${ev.id}`}>{body}</Link>
    : <div className={cls} data-testid={`event-booking-${ev.kind}-${ev.id}`}>{body}</div>;
};

export default EventBookingCard;
